import { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";


const rulesetColours = {
    [Ruleset.FINKEL.getID()]: "var(--color-ruleset-finkel)",
    [Ruleset.BLITZ.getID()]: "var(--color-ruleset-blitz)",
    [Ruleset.MASTERS.getID()]: "var(--color-ruleset-masters)",
    [Ruleset.OLD_MASTERS.getID()]: "var(--color-ruleset-masters)",
};


/** The ruleset's colour as a CSS value, for style props. */
export function getRulesetColourByID(rulesetID: string): string {
    return rulesetColours[rulesetID] ?? "var(--color-text-muted)";
}


export function getRulesetColour(ruleset: Ruleset): string {
    return getRulesetColourByID(ruleset.getID());
}
